import { FC } from "react";
import { Stack } from "@mui/material";
import { useAppSelector } from "@/store/hooks";
import { taskViewDetailsSelector } from "@/store/task-management/selectors/views-hierarchy/taskViewDetailsSelector";
import { DataPieceChip } from "@/components/common/DataPieceChip";
import { money } from "@/utils/numeral/money";

export const TaskManagementViewDetails: FC = () => {
  const details = useAppSelector(taskViewDetailsSelector);

  return (
    <Stack direction="row" spacing={1}>
      <DataPieceChip title="Tasks" data={String(details?.itemsCount ?? 0)} />
      <DataPieceChip
        title="Monthly Price"
        data={money(details?.totalCost ?? 0)}
      />
    </Stack>
  );
};
